// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup_wrap[data-v-59cde72c]{\n  -ms-overflow-style: none;\n}\n.popup_wrap[data-v-59cde72c]::-webkit-scrollbar{\n  display:none;\n}\n\n", ""]);
// Exports
module.exports = exports;
